module.exports = __webpack_public_path__ + "img/Motorbike-Outline.b8c89144.png";